import React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  variant?: 'block';
  value: any;
  entitled: string;
  iconComponent?: React.ReactNode;
  name: string;
  position?: string;
  onChange: React.ReactEventHandler | any;
  choice: any;
  id: string;
}

const RadioButton: React.FC<Props> = ({
  value,
  entitled,
  className,
  iconComponent,
  variant,
  name,
  position,
  onChange,
  choice,
  id,
}) => {
  const _className = clsx(
    className,
    'radio-button',
    iconComponent && 'with--icon',
    variant && `radio--${variant}`,
  );

  return (
    <div className={_className} data-cy={`appointment-type-${value}`}>
      {position === 'top' && <label htmlFor={id}>{entitled}</label>}
      <input
        onChange={onChange}
        type="radio"
        name={name}
        value={value}
        id={id}
        checked={choice === value}
      />
      {position === 'bottom' && <label htmlFor={value}>{entitled}</label>}
      {/* style for organize elements inline */}
      {!position && <label htmlFor={value}>{entitled}</label>}
      {iconComponent && <>{iconComponent}</>}
      <div
        className="check"
        onClick={() => {
          onChange({
            target: {
              value,
            },
          });
        }}
      />
    </div>
  );
};

export default RadioButton;
